import { useCallback } from 'react';
import { SchemaDatapointEnumOptions } from '@rossum/api-client/schemas';
import { Autocomplete, TextField } from '@rossum/ui/material';
import {
  GridRenderEditCellParams,
  useGridApiContext,
} from '@rossum/ui/x-data-grid-pro';

export const AutocompleteEditCell = (
  params: GridRenderEditCellParams<
    Record<never, never>,
    { preview: string }
  > & {
    options: SchemaDatapointEnumOptions | undefined;
  }
) => {
  const { id, value, field, options } = params;
  const apiRef = useGridApiContext();

  const displayValue: string =
    typeof value === 'string' ? value : (value?.preview ?? '');

  const handleChange = useCallback(
    (
      _event: React.SyntheticEvent,
      newValue: string | SchemaDatapointEnumOptions[0] | null
    ) => {
      const updatedValue = (() => {
        if (newValue === null) {
          return { preview: '' };
        }
        if (typeof newValue === 'string') {
          return { preview: newValue };
        }
        return { preview: newValue.value };
      })();

      apiRef.current.setEditCellValue({
        id,
        field,
        value: updatedValue,
      });
    },
    [apiRef, id, field]
  );

  return (
    <Autocomplete
      fullWidth
      freeSolo
      options={options ?? []}
      value={displayValue}
      isOptionEqualToValue={(option, currentValue) => {
        if (typeof currentValue === 'string') {
          return option.value === currentValue;
        }
        return option.value === currentValue?.value;
      }}
      onChange={handleChange}
      renderInput={inputParams => <TextField {...inputParams} />}
      size="small"
      sx={{
        p: 1,
        height: '100%',
        '& .MuiInputBase-root': {
          height: '100%',
          boxSizing: 'border-box',
        },
      }}
    />
  );
};
